import React, {  useState , useEffect} from "react";
// import { ColorModeContext } from "../../theme";
import {
  useTheme,
  Box,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  styled,
  Typography,
  Avatar,
  Divider,
  alpha,Tooltip, Popover,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import SearchIcon from "@mui/icons-material/Search";
import HttpsIcon from "@mui/icons-material/Https";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useProSidebar } from "react-pro-sidebar";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthProvider";
import Badge from '@mui/material/Badge';
import MailIcon from '@mui/icons-material/Mail';
import SettingsIcon from '@mui/icons-material/Settings';

const baseUrl = process.env.REACT_APP_API_BASE_URL;

// Styled MenuItem for profile, change password, and sign out
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  padding: "10px 16px",
  display: "flex",
  alignItems: "center",
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.15),
    color: theme.palette.primary.main,
  },
}));

const Topbar = ({ showSearchInput, userAvatar }) => {
  const theme = useTheme();
  // const colorMode = useContext(ColorModeContext);
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
 
  const { resetAuth,role,userId,refreshKey,oId,schoolName,firstName,board,orgName} = useAuth();
  const [profileImage, setProfilePic] = useState(null);
  const [companyName, setcompanyName] = useState(null);
  const [empName, setempName] = useState(null)
  const notificationCount = 5; // Replace with dynamic count if applicable

  

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // const handleNotificationClick = () => {
  //   console.log("Notification icon clicked");
  //   // Add your notification logic here
  // };
  const notifications = ["New message received", "Meeting at 3 PM", "System update available"];


  const [notifanchorEl, setNotifAnchorEl] = useState(null);

  // Handle Click
  const handleNotificationClick = (event) => {
    setNotifAnchorEl(event.currentTarget);
  };

  // Close Popover
  const handleClose = () => {
    setNotifAnchorEl(null);
  };

  const open = Boolean(notifanchorEl);
  const id = open ? "notification-popover" : undefined;







  

  // LOG OUT
  const handleSignOut = async () => {
    const token = sessionStorage.getItem("token");
    try {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const response = await fetch(`${baseUrl}/api/v1/auth/logout`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      // Clear only the specific items you want to remove
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("loginEmail");
      sessionStorage.removeItem("email");
      sessionStorage.removeItem("role");
      sessionStorage.removeItem("authContext");
      sessionStorage.removeItem("selectedSubmenu");
      sessionStorage.removeItem("receiptRowData");
  sessionStorage.removeItem("receiptCategoryType");
   sessionStorage.removeItem("paymentListStudent");
   sessionStorage.removeItem("disabledSaveButtons");
    sessionStorage.removeItem("studentResult");
    sessionStorage.removeItem("studentProgress");
    sessionStorage.removeItem("busId");
    sessionStorage.removeItem("route");
    sessionStorage.removeItem("studentName");
    sessionStorage.removeItem("soldItemData");
    sessionStorage.removeItem("busNumberPlate");



      resetAuth();
      navigate("/");
    } catch (error) {
      console.error("Error during sign out:", error);
    }
  };

  // const Role = sessionStorage.getItem("role");
  // Fetch Profile
  // const fetchProfilePic = async () => {
  //   try {
  //     const response = await fetch(`${baseUrl}/api/v1/sales/getProfile/${userId}`);
  //     const data = await response.json();

  //     if (data && data.profilePic) {
  //       setProfilePic(data.profilePic);  // Directly set the base64 string for profilePic
  //     } else {
  //       console.error("Profile pic data is not available");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching profile picture:", error);
  //   }
  // };
  const Role = sessionStorage.getItem("role");

// Define API endpoints for each role
// const roleApiEndpoints = {
  
//   ORGANIZATION: `${baseUrl}/api/v1/organisation/${oId}`,
//   ADMISSION_FEE: `${baseUrl}/api/v1/organisation/${oId}`,
//   STORE_DEPARTMENT: `${baseUrl}/api/v1/organisation/${oId}`,
 
// };

// const fetchProfilePic = async () => {
//   try {
//     // Get the API endpoint for the current role
//     const apiEndpoint = roleApiEndpoints[Role];

//     if (!apiEndpoint) {
//       console.error("Unknown role, unable to fetch profile picture");
//       return;
//     }

//     const response = await fetch(apiEndpoint);
//     const data = await response.json();

//     // Determine whether to set the profile picture or company logo
//     if (data) {
//       if (data.profilePic) {
//         setProfilePic(data.profilePic); // Set the profile picture for other roles
//         setempName(data.firstname+" "+ data.lastname)
//       } else if (data.companyLogo) {
//         setProfilePic(data.companyLogo); // Set the company logo for the organization
//         setcompanyName(data.companyName)
//       } else {
//         console.error("Neither profilePic nor companyLogo is available in the response");
//       }
//     } else {
//       console.error("No data received from the API");
//     }
//   } catch (error) {
//     console.error("Error fetching profile picture:", error);
//   }
// };




  // useEffect(() => {
  //   fetchProfilePic();
  // }, [refreshKey]);



  const handleProfile = () => {
    switch (Role) {
     
      case "ORGANIZATION":
        navigate("/OrganizationProfile");
        break;
      
       
      default:
        console.warn("Unknown role:", Role);
        break;
    }
  
    handleMenuClose();
  };

  const handleSetting = () => {
    switch (board) {
      case "SSC":
        navigate("/Settings");
        break;
        case "INTERMEDIATE":
          navigate("/IntermediateSettings");
          break;
     
       
      default:
        console.warn("Unknown role:", Role);
        break;
    }
  
    handleMenuClose();
  };
  

  const handleChangePassword = () => {
    navigate("/ChangePassword");
    handleMenuClose();
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        backgroundColor: theme.palette.background.default,
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        padding: "10px 24px",
        height: "50px",
        width: "100vw", // Full viewport width
        transition: "background-color 0.3s",
      }}
    >
      <Box display="flex" alignItems="center">
        {broken && !rtl && (
          <IconButton sx={{ marginRight: "12px" }} onClick={() => toggleSidebar()}>
            <MenuOutlinedIcon sx={{ color: theme.palette.text.primary }} />
          </IconButton>
        )}
        {showSearchInput && (
          <Box
            display="flex"
            alignItems="center"
            sx={{
              backgroundColor: theme.palette.grey[100],
              borderRadius: 2,
              padding: "4px 12px",
              boxShadow: "inset 0px 2px 4px rgba(0, 0, 0, 0.1)",
              width: "400px",
              maxWidth: "100%",
            }}
          >
            <SearchIcon sx={{ color: theme.palette.text.secondary }} />
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search"
              inputProps={{ "aria-label": "search" }}
            />
          </Box>
        )}
      </Box>
      
      <Box display="flex" alignItems="center">
{/* 
      <IconButton
    sx={{
      marginRight: "20px", // Adjust spacing
      position: "relative",
    }}
    onClick={handleNotificationClick} // Define the function for notification click
  >
    <Badge
      badgeContent={notificationCount} // Replace with your notification count
      color="error"
      overlap="circular"
      sx={{
        "& .MuiBadge-badge": {
          right: -3,
          top: 3,
          border: `2px solid ${theme.palette.background.paper}`,
          padding: "0 4px",
        },
      }}
    >
      < MailIcon  sx={{ color: theme.palette.text.primary }} />
    </Badge>

  </IconButton> */}






         {/* Notification Icon with Badge */}
         {/* <Tooltip title="Notifications"  arrow 
      enterDelay={300} // Delay before showing tooltip (ms)
      leaveDelay={200} // Delay before hiding tooltip (ms)
      >
  <IconButton
    sx={{
      marginRight: "20px", // Adjust spacing
      position: "relative",
    }}
    onClick={handleNotificationClick} // Define the function for notification click
  >
    <Badge
      badgeContent={notificationCount} // Replace with your notification count
      color="error"
      overlap="circular"
      sx={{
        "& .MuiBadge-badge": {
          right: -3,
          top: 3,
          border: `2px solid ${theme.palette.background.paper}`,
          padding: "0 4px",
        },
      }}
    >
      <NotificationsIcon sx={{ color: theme.palette.text.primary }} />
    </Badge>
  </IconButton>
  </Tooltip> */}
   {/* Notification Icon with Badge */}

   

   {/* <Tooltip title="Notifications" arrow enterDelay={300} leaveDelay={200}>
        <IconButton
          sx={{ marginRight: "20px", position: "relative" }}
          onClick={handleNotificationClick}
        >
          <Badge
            badgeContent={notifications.length} // Dynamic count
            color="error"
            overlap="circular"
            sx={{
              "& .MuiBadge-badge": {
                right: -3,
                top: 3,
                border: `2px solid ${theme.palette.background.paper}`,
                padding: "0 4px",
              },
            }}
          >
            <NotificationsIcon sx={{ color: theme.palette.text.primary }} />
          </Badge>
        </IconButton>
      </Tooltip> */}

      {/* Notification Popover */}
      {/* <Popover
        id={id}
        open={open}
        anchorEl={notifanchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        sx={{ marginTop: "8px" }} // Space between icon and popover
      >
        <Box sx={{ width: 250, p: 2 }}>
          <Typography variant="h6">Notifications</Typography>
          {notifications.length > 0 ? (
            notifications.map((notification, index) => (
              <Typography key={index} variant="body2" sx={{ mt: 1 }}>
                {notification}
              </Typography>
            ))
          ) : (
            <Typography variant="body2" sx={{ mt: 1, color: "gray" }}>
              No new notifications
            </Typography>
          )}
        </Box>
      </Popover> */}
      















        {/* Welcome Text */}
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-end"
          sx={{ marginRight: "15px" }}
        >
          <Typography variant="body1" sx={{ fontWeight: "bold"  ,color:"#3C3972"}}>
            Hello!
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: "bold" ,color:"#E44C68", fontSize:'15px'}}>
          {role === "ORGANIZATION" ? firstName : firstName}

          </Typography>
        </Box>

        {/* Profile Icon Button with Avatar */}
        <IconButton
          onClick={handleMenuOpen}
          sx={{
            // backgroundColor: alpha(theme.palette.primary.light, 0.2),
            // "&:hover": {
            //   backgroundColor: alpha(theme.palette.primary.light, 0.4),
            // },
            borderRadius: "45%",
            padding: "4px",
            transition: "background-color 0.3s",
          }}
        >
          {/* <Avatar
            alt="User Avatar"
            src={profileImage ? `data:image/jpeg;base64,${profileImage}` : ""} 
            sx={{ width: 35, height: 35 }}
          /> */}
          <Avatar
            alt="User Avatar"
            src="/assets/profile.jpeg"
            sx={{ width: 50, height: 50 }}
          />
        </IconButton>

        {/* Menu Dropdown */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          PaperProps={{
            sx: {
              backgroundColor: theme.palette.background.paper,
              boxShadow: "0 6px 16px rgba(0, 0, 0, 0.15)",
              borderRadius: "12px",
              padding: "8px",
              minWidth: "200px",
            },
          }}
        >
          <Typography
            variant="h6"
            sx={{ padding: "8px", fontWeight: "bold", textAlign: "center" }}
          >
            Account
          </Typography>
          <Divider sx={{ margin: "8px 0" }} />
          {Role === "ORGANIZATION" && (
          <StyledMenuItem 
          onClick={handleProfile}
          
          >
            <AccountCircleIcon
              sx={{ marginRight: 1, color: theme.palette.primary.main, fontSize: "20px" }}
            />
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              Profile
            </Typography>
          </StyledMenuItem> )}

          {Role === "PRINCIPAL" && (

          <StyledMenuItem 
          onClick={handleSetting}
          
          >
            <SettingsIcon
              sx={{ marginRight: 1, color: theme.palette.primary.main, fontSize: "20px" }}
            />
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              Settings
            </Typography>
          </StyledMenuItem>)}

          <StyledMenuItem onClick={handleChangePassword}>
            <HttpsIcon
              sx={{ marginRight: 1, color: theme.palette.secondary.main, fontSize: "20px" }}
            />
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              Change Password
            </Typography>
          </StyledMenuItem>

          <Divider sx={{ margin: "8px 0" }} />
          <StyledMenuItem onClick={handleSignOut}>
            <ExitToAppIcon
              sx={{ marginRight: 1, color: theme.palette.error.main, fontSize: "20px" }}
            />
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              Sign Out
            </Typography>
          </StyledMenuItem>
        </Menu>

         
      </Box>
    </Box>
  );
};

export default Topbar;